export default function (caseNumber) {
  return {
    name: "Request CDR",
    pageInfo: {
      text: "Use this form to request a CDR.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "fileType",
            value: "CDR Request Document",
            widget: "text",
            style: {
              display: "none",
            },
          },
          {
            machine_name: "case_note",
            widget: "text_area",
            label: "Case Note",
            validate: ["required"],
            inputLimit: 4000,
            rows: 7,
          },
          // {
          //   machine_name: "case_number",
          //   widget: "text",
          //   label: "Case Number",
          //   disabled: true,
          //   value: caseNumber || ""
          // },
          {
            machine_name: "files",
            widget: "file_upload",
            file_upload: { fileType: "CDR Request Document" },
            accept_multiple: false,
            checkFilesAdded: true,
            documentAuth: "dh",
          },
          {
            machine_name: "document_description",
            widget: "text",
            label: "Document Description",
            validate: ["required"],
            maxLength: 100,
            isVisible: {
              when: "files",
              is: [undefined, null],
              operator: "filesExist",
              hideStyles: true,
            },
          },
        ],
      },
    ],
  };
}
